import React from 'react';
import colors from '../ColorConfig/colorconfig';

const { white, primaryRgb, primary } = colors;

const ProcessStep = ({
  step,
  index,
  isEven,
  isStepVisible,
  isHovered,
  isExpanded,
  isLeftSide,
  shouldAnimateOut,
  onStepClick,
  onMouseEnter,
  onMouseLeave,
  isDesktop
}) => {
  const IconComponent = step.icon;

  if (isDesktop) {
    return (
      <div 
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '180px',
          marginTop: isEven ? '0' : '80px',
          opacity: isStepVisible ? 1 : 0,
          transform: isStepVisible ? 'translateY(0)' : (shouldAnimateOut ? 'translateY(-20px)' : 'translateY(20px)'),
          transition: 'all 0.3s ease-out',
        //  cursor: 'revert',
          position: 'relative',
          zIndex: isHovered ? 100 : 3
        }}
        onMouseEnter={() => onMouseEnter(index)}
        onMouseLeave={onMouseLeave}
      >
        <StepNumberIndicator step={step} isHovered={isHovered} />
        <StepIcon 
          step={step} 
          IconComponent={IconComponent} 
          isHovered={isHovered} 
        />
        <StepContent 
          step={step} 
          isHovered={isHovered} 
          isDesktop={isDesktop}
        />
        <StepConnector step={step} isHovered={isHovered} />
        <FloatingParticles step={step} isHovered={isHovered} />
      </div>
    );
  }

  // Mobile version
  return (
    <div 
      style={{ 
        width: '45%',
        opacity: isStepVisible ? 1 : 0,
        transform: isStepVisible ? 'translateY(0) scale(1)' : (shouldAnimateOut ? 'translateY(-10px) scale(0.95)' : 'translateY(10px) scale(0.95)'),
        transition: 'all 0.3s ease-out',
        transitionDelay: isStepVisible ? `${index * 0.15}s` : '0s',
        cursor: 'pointer',
        position: 'relative',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: isLeftSide ? 'flex-start' : 'flex-end'
      }}
      onClick={() => onStepClick(index)}
      onMouseEnter={() => onMouseEnter(index)}
      onMouseLeave={onMouseLeave}
    >
      <MobileStepNumber 
        step={step} 
        isHovered={isHovered} 
        isLeftSide={isLeftSide} 
      />
      <MobileStepContent 
        step={step} 
        isHovered={isHovered} 
        isLeftSide={isLeftSide}
        isExpanded={isExpanded}
      />
    </div>
  );
};

const StepNumberIndicator = ({ step, isHovered }) => (
  <div style={{
    position: 'absolute',
    top: '-35px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '30px',
    height: '30px',
    backgroundColor: isHovered ? step.color : primary,
    color: white,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    opacity: isHovered ? 1 : 0,
    transition: 'all 0.3s ease',
    zIndex: 10,
    boxShadow: isHovered ? `0 0 15px ${step.color}` : 'none'
  }}>
    {step.id}
  </div>
);

const StepIcon = ({ step, IconComponent, isHovered }) => (
  <div 
    style={{
      width: "80px",
      height: "80px",
      backgroundColor: white,
      borderRadius: "50%",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '20px',
      border: `3px solid ${step.color}`,
      boxShadow: isHovered 
        ? `0 0 30px ${step.color}, 0 0 60px ${step.color}40, 0 20px 40px rgba(0,0,0,0.3)` 
        : `0 8px 30px rgba(${primaryRgb}, 0.2)`,
      transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      transform: isHovered 
        ? "scale(1.25) translateY(-10px) rotate(5deg)" 
        : "scale(1) translateY(0) rotate(0deg)",
      position: 'relative',
      overflow: 'visible'
    }}
  >
    <IconComponent 
      size={32} 
      color={isHovered ? step.color : step.color} 
      strokeWidth={2.5}
      style={{
        transition: 'all 0.4s ease',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        filter: isHovered ? 'drop-shadow(0 0 8px rgba(255,255,255,0.8))' : 'none'
      }}
    />
    {isHovered && <RippleEffect step={step} />}
  </div>
);

const RippleEffect = ({ step }) => (
  <>
    <div style={{
      position: 'absolute',
      top: '-5px',
      left: '-5px',
      width: 'calc(100% + 10px)',
      height: 'calc(100% + 10px)',
      borderRadius: '50%',
      border: `2px solid ${step.color}`,
      opacity: 0,
      animation: 'ripple1 1.5s ease-out infinite'
    }} />
    <div style={{
      position: 'absolute',
      top: '-10px',
      left: '-10px',
      width: 'calc(100% + 20px)',
      height: 'calc(100% + 20px)',
      borderRadius: '50%',
      border: `2px solid ${step.color}`,
      opacity: 0,
      animation: 'ripple2 1.5s ease-out infinite 0.3s'
    }} />
  </>
);

const StepContent = ({ step, isHovered, isDesktop }) => (
  <div 
    style={{
      backgroundColor: white,
      borderRadius: "15px",
      padding: "20px",
      width: isDesktop ? "170px" : "auto",
      textAlign: "center",
      border: `2px solid ${isHovered ? step.color : step.color}`,
      boxShadow: isHovered 
        ? `0 20px 40px ${step.color}60, 0 10px 20px ${step.color}40` 
        : `0 8px 25px rgba(${primaryRgb}, 0.15)`,
      transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      transform: isHovered && isDesktop
        ? "translateY(-15px) scale(1.05)" 
        : "translateY(0) scale(1)",
      backdropFilter: "blur(10px)",
      marginBottom: isDesktop ? '20px' : '0'
    }}
  >
    <h6 style={{ 
      color: isHovered ? step.color : step.color, 
      fontSize: isDesktop ? "17px" : "15px",
      fontWeight: "bold",
      marginBottom: "12px",
      transition: 'all 0.4s ease',
      textShadow: isHovered ? '0 2px 4px rgba(0,0,0,0.3)' : 'none'
    }}>
      {step.title}
    </h6>
    {isDesktop && (
      <p style={{ 
        fontSize: "14px", 
        lineHeight: "1.4",
        color: isHovered ? step.color : step.color,
        transition: 'all 0.4s ease',
        textShadow: isHovered ? '0 1px 2px rgba(0,0,0,0.2)' : 'none',
        margin: 0,
        opacity: isHovered ? 0.95 : 0.8
      }}>
        {step.description}
      </p>
    )}
  </div>
);

const StepConnector = ({ step, isHovered }) => (
  <div 
    style={{
      width: "24px",
      height: "24px",
      backgroundColor: step.color,
      borderRadius: "50%",
      boxShadow: isHovered ? `0 0 25px ${step.color}` : 'none',
      transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      transform: isHovered 
        ? "scale(1.8) rotate(180deg)" 
        : "scale(1) rotate(0deg)"
    }}
  />
);

const FloatingParticles = ({ step, isHovered }) => {
  if (!isHovered) return null;
  
  return (
    <>
      <div style={{
        position: 'absolute',
        top: '-30px',
        left: '-20px',
        color: step.color,
        fontSize: '20px',
        pointerEvents: 'none',
        animation: 'float1 2s ease-in-out infinite'
      }}>✦</div>
      <div style={{
        position: 'absolute',
        top: '-35px',
        right: '-20px',
        color: step.color,
        fontSize: '16px',
        pointerEvents: 'none',
        animation: 'float2 2s ease-in-out infinite 0.5s'
      }}>✧</div>
      <div style={{
        position: 'absolute',
        bottom: '-30px',
        left: '50%',
        color: step.color,
        fontSize: '18px',
        pointerEvents: 'none',
        animation: 'float3 2s ease-in-out infinite 1s',
        transform: 'translateX(-50%)'
      }}>✦</div>
    </>
  );
};

const MobileStepContent = ({ step, isHovered, isLeftSide, isExpanded }) => (
  <div style={{
    borderRadius: "12px",
    padding: "15px",
    border: `2px solid ${isHovered ? step.color : step.color}`,
    background: 'transparent',
    boxShadow: isHovered 
      ? `0 0 20px ${step.color}40, 0 5px 15px ${step.color}20` 
      : `0 4px 15px ${step.color}20`,
    transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    width: '140px', // Fixed width
    height: isExpanded ? 'auto' : '70px', // Fixed height when not expanded, auto when expanded
    minHeight: '60px', // Minimum height
    position: 'relative',
    backdropFilter: 'blur(10px)',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // Center content vertically
    overflow: 'hidden' // Prevent content from overflowing
  }}>
    <h5 style={{ 
      color: isHovered ? step.color : step.color,
      fontSize: "14px",
      marginBottom: isExpanded ? "8px" : "0", // Remove bottom margin when not expanded
      transition: 'all 0.3s ease',
      textShadow: isHovered ? `0 0 10px ${step.color}80` : 'none',
      textAlign: isLeftSide ? 'left' : 'right',
      fontWeight: '600',
      lineHeight: '1.2', // Better line height for single line
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: isExpanded ? 'unset' : '2', // Limit to 2 lines when not expanded
      WebkitBoxOrient: 'vertical'
    }}>
      {step.title}
    </h5>
    {isExpanded && (
      <p style={{ 
        fontSize: "12px", 
        lineHeight: "1.4", 
        color: isHovered ? step.color : step.color,
        transition: 'all 0.3s ease',
        textShadow: isHovered ? `0 0 5px ${step.color}60` : 'none',
        margin: 0,
        opacity: isHovered ? 1 : 0.9,
        textAlign: isLeftSide ? 'left' : 'right',
        animation: 'fadeIn 0.3s ease-in'
      }}>
        {step.description}
      </p>
    )}
  </div>
);

const MobileStepNumber = ({ step, isHovered, isLeftSide }) => (
  <div style={{
    position: 'absolute',
    top: '-12px',
    [isLeftSide ? 'left' : 'right']: '15px',
    width: '24px',
    height: '24px',
    backgroundColor: isHovered ? white : step.color,
    color: isHovered ? step.color : white,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 'bold',
    opacity: isHovered ? 1 : 0.9,
    transition: 'all 0.3s ease',
    zIndex: 10,
    boxShadow: isHovered ? `0 0 15px ${step.color}` : `0 0 10px ${step.color}80`
  }}>
    {step.id}
  </div>
);

export default ProcessStep;